import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import EditActionPlanForm from './EditActionPlanForm'
import ModalHeader from './ModalHeader'
import { useCustomToken } from '@btime/react-session'

const CreateActionPlanModal = props => {
  const formToken = useCustomToken('formToken')

  return (
    <ControlledModal width="32rem" {...props} publicModal={!!formToken}>
      <ModalHeader />
      <EditActionPlanForm />
    </ControlledModal>
  )
}

export default CreateActionPlanModal
